/** 插件类型 */
export const PluginEnum = {
    AI_EXPEND_IMAGE: 'image_expand',
    AI_MODIFY_IMAGE: 'image_manipulation',
    AI_GENERATE_IMAGE: 'image_generate',
    AI_TEXT: 'ai_text',
    AI_RESIZE: 'ai_resize',
    BATCH_TEMPLATE: 'batch_template',
    IMAGE_TRANSLATION: 'image_translation',
};
